import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { WalletImport } from '@root/features/wallet/import-wallet/ui/import-wallet'
import { useTranslation } from '@root/shared/localization'

import { walletsManagerModelAtom } from '../../atoms'

import { WalletDetailsSection } from './wallet-details-section'

type WalletDetailsImportProps = {
  onClose: () => void
}

export const WalletDetailsImport: React.FC<WalletDetailsImportProps> = ({
  onClose: onOpenChange,
}) => {
  const { t } = useTranslation()
  const [model] = useAtom(walletsManagerModelAtom)
  const clearSelectedWallet = useAction(model.clearSelectedWallet)

  return (
    <Root title={t('wallet.import_wallet')} onClose={clearSelectedWallet}>
      <Body onClose={onOpenChange} device="desktop" />
    </Root>
  )
}

const Root = styled(WalletDetailsSection)`
  background: var(--background-1);
`

const Body = styled(WalletImport)`
  display: grid;
  height: 100%;
  grid-template-rows: 1fr auto;
  padding-block: 10px;
  padding-inline: 10px;
`
